import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import AccountForm from './components/AccountForm';
import AccountList from './components/AccountList';
import TradeForm from './components/TradeForm';
import TradeTable from './components/TradeTable';
import AccountSelector from './components/AccountSelector';
import Charts from './components/Charts';
import DataImportExport from './components/DataImportExport';

function App() {
  // 全局状态
  const [accounts, setAccounts] = useState([]);
  const [trades, setTrades] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState('');
  // 汇率状态（后续图表等也会用到）
  const [exchangeRates, setExchangeRates] = useState({ USD: 7.19 });
  const initialized = useRef(false);

  // 只在挂载时读取 localStorage
  useEffect(() => {
    if (!initialized.current) {
      const savedAccounts = localStorage.getItem('accounts');
      const savedTrades = localStorage.getItem('trades');
      if (savedAccounts) setAccounts(JSON.parse(savedAccounts));
      if (savedTrades) setTrades(JSON.parse(savedTrades));
      initialized.current = true;
    }
  }, []);

  // 只要 accounts 变化就保存
  useEffect(() => {
    if (initialized.current) {
      localStorage.setItem('accounts', JSON.stringify(accounts));
    }
  }, [accounts]);

  // 只要 trades 变化就保存
  useEffect(() => {
    if (initialized.current) {
      localStorage.setItem('trades', JSON.stringify(trades));
    }
  }, [trades]);

  return (
    <div className="App">
      <DataImportExport
        accounts={accounts}
        trades={trades}
        setAccounts={setAccounts}
        setTrades={setTrades}
      />
      <AccountForm accounts={accounts} setAccounts={setAccounts} />
      <AccountList accounts={accounts} setAccounts={setAccounts} trades={trades} setTrades={setTrades} />
      <TradeForm accounts={accounts} trades={trades} setTrades={setTrades} />
      <AccountSelector
        accounts={accounts}
        trades={trades}
        selectedAccount={selectedAccount}
        setSelectedAccount={setSelectedAccount}
        exchangeRates={exchangeRates}
      />
      <TradeTable accounts={accounts} trades={trades} selectedAccount={selectedAccount} setTrades={setTrades} />
      <Charts accounts={accounts} trades={trades} selectedAccount={selectedAccount} exchangeRates={exchangeRates} />
    </div>
  );
}

export default App;
